import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  InputAdornment
} from "@mui/material";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import TextInputField from "../../component/ui/FormFields/TextInputField";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerDetailsRequest } from "../../redux/Customers/actions/customerActions";
import CustomButton from "../../component/ui/FormFields/Button";
import Loading from "../../component/ui/Loading";
import {
  CUSTOMERS,
  EDIT_CUSTOMER
} from "../../component/common/Routes/AppRoutes";
import { useForm } from "react-hook-form";
import { VENDOR_EDIT_CUSTOMER } from "../../component/common/Routes/VendorRoutes";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PublicIcon from "@mui/icons-material/Public";
import PinDropIcon from "@mui/icons-material/PinDrop";
import FlagIcon from "@mui/icons-material/Flag";
import CakeIcon from "@mui/icons-material/Cake";
import BadgeIcon from "@mui/icons-material/Badge";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import GenderRadioGroup from "../../component/ui/FormFields/GenderRadioGroup";

const ViewCustomer = () => {
  const { customerId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control } = useForm();

  const customerDetailsState = useSelector(
    (state) => state.customers.customerDetails
  );
  const user = useSelector((state) => state.auth.user);
  const customerDetails = customerDetailsState?.data || {};
  console.log(customerDetails?.data);
  const viewLoading = customerDetailsState?.loading || false;
  const error = customerDetailsState?.error || null;
  const statusValue = customerDetails.data?.status;
  const status = statusValue === 0 ? "Active" : "Inactive";
  const genderValue = customerDetails.data?.familyMember?.gender_type || "";
  useEffect(() => {
    if (customerId) {
      dispatch(fetchCustomerDetailsRequest(customerId));
    }
  }, [dispatch, customerId]);

  if (viewLoading) {
    return <Loading text="Loading Customer details..." />;
  }

  if (error || !Object.keys(customerDetails).length) {
    return (
      <Box textAlign="center" py={5}>
        <Typography variant="h6" color="error">
          {error || "No Customer data found!"}
        </Typography>
        <CustomButton
          text="Back to Customers"
          onClick={() => navigate(CUSTOMERS)}
        />
      </Box>
    );
  }

  const fields = [
    {
      label: "First Name",
      value: customerDetails.data.first_name || "-",
      xs: 12,
      sm: 6,
      icon: <PersonIcon />
    },
    {
      label: "Last Name",
      value: customerDetails.data.last_name || "-",
      xs: 12,
      sm: 6,
      icon: <PersonIcon />
    },
    {
      label: "Email Address",
      value: customerDetails.data.email || "-",
      xs: 12,
      sm: 6,
      icon: <EmailIcon />
    },
    {
      label: "Country Code",
      value: customerDetails.data.country_code || "-",
      xs: 4,
      sm: 2,
      icon: <FlagIcon />
    },
    {
      label: "Mobile Number",
      value: customerDetails.data.phone || "-",
      xs: 8,
      sm: 4,
      icon: <PhoneIcon />
    },
    {
      label: "Date of Birth",
      value: customerDetails.data?.familyMember?.dob || "-",
      xs: 12,
      sm: 6,
      icon: <CakeIcon />
    },
    {
      label: "Nationality",
      value: customerDetails.data?.familyMember?.nationality || "-",
      xs: 12,
      sm: 6,
      icon: <FlagIcon />
    },
    {
      label: "Passport Number",
      value: customerDetails.data?.familyMember?.passport_number || "-",
      xs: 12,
      sm: 6,
      icon: <BadgeIcon />
    },
    {
      label: "Aadhar Number",
      value: customerDetails.data?.familyMember?.aadhar_number || "-",
      xs: 12,
      sm: 6,
      icon: <FingerprintIcon />
    },
    {
      label: "Address 1",
      value: customerDetails.data.address1 || "-",
      xs: 12,
      sm: 6,
      icon: <HomeIcon />
    },
    {
      label: "Address 2",
      value: customerDetails.data.address2 || "-",
      xs: 12,
      sm: 6,
      icon: <HomeIcon />
    },
    {
      label: "Country",
      value: customerDetails.data.country_name || "-",
      xs: 12,
      sm: 6,
      icon: <PublicIcon />
    },

    {
      label: "State",
      value: customerDetails.data.state_name || "-",
      xs: 12,
      sm: 6,
      icon: <LocationCityIcon />
    },
    {
      label: "City",
      value: customerDetails.data.city_name || "-",
      xs: 12,
      sm: 6,
      icon: <LocationCityIcon />
    },
    {
      label: "Pincode",
      value: customerDetails.data.pincode || "-",
      xs: 12,
      sm: 6,
      icon: <PinDropIcon />
    }
  ];

  return (
    <Box className="container">
      <Card>
        <CardContent sx={{ padding: 4 }}>
          <Typography variant="h5" className="form-heading" gutterBottom>
            View Customer
          </Typography>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
            className="customer-form-margin"
          >
            {fields.map((field, index) => (
              <Grid item xs={field.xs} sm={field.sm} key={index}>
                <TextInputField
                  label={field.label}
                  value={field.value}
                  disabled={true}
                  startAdornment={
                    <InputAdornment position="start">
                      {field.icon}
                    </InputAdornment>
                  }
                />
              </Grid>
            ))}

            <Grid item xs={12} sm={6}>
              <GenderRadioGroup
                name="gender"
                control={control}
                defaultValue={genderValue}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <StatusRadioGroup
                name={"status"}
                control={control}
                defaultValue={status}
                disabled={true}
              />
            </Grid>
          </Grid>
          {/* Buttons */}
          <Grid item xs={12}>
            <Box className="button-container">
              <CustomButton
                variant="contained"
                className="cancel-button"
                type="button"
                text={"Back"}
                onClick={() => navigate(-1)}
              />
              <CustomButton
                variant="contained"
                className="success-button"
                text="Edit"
                onClick={() => {
                  const editRoute =
                    user.role === "Vendor"
                      ? VENDOR_EDIT_CUSTOMER.replace(
                          ":customerId",
                          customerDetails.data.id
                        )
                      : EDIT_CUSTOMER.replace(
                          ":customerId",
                          customerDetails.data.id
                        );
                  navigate(editRoute);
                }}
              />
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ViewCustomer;
